import { render, staticRenderFns } from "./PostbackReissue.vue?vue&type=template&id=37c63cd8"
import script from "./PostbackReissue.vue?vue&type=script&lang=js"
export * from "./PostbackReissue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports